import uniq from 'lodash/uniq';

export default function fetchFormDataHandler (data) {

  const product =  uniq(data.map(dataObj => dataObj.product.name));

  const package_ = product.reduce((result, item) => {

    data.forEach((key, index) => {
      result[item] = result[item] || [];
      result[item][index] = key.product.name === item ? key.name : null;
    });

    return result;
  }, {});

  return {
    product: product,
    package_: Object.keys(package_)
      .map(key => ({key: key, data: package_[key]}))
      .map(dataObj => ({
        product: dataObj.key,
        packages:
          dataObj.key ==='Crop-Monitoring'
            ? ['professional']
            : dataObj.data.filter(data => data !== null)
      })),
  };
}
